import SPKApi from './SPKApi';

export default SPKApi;
